import PayrollComponent from 'components/Payroll/PayrollComponent';
import PermissionGuard from 'components/Global/PermissionGuard'; 
export const Payroll = () => {
	return (
		<PermissionGuard permission="Allow_Run_Payroll">
			<PayrollComponent />
		</PermissionGuard>
	);
};
